import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.594 6.21967C18.3011 5.92678 17.8263 5.92678 17.5334 6.21967L12.4069 11.3462L7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.9534 6.48594 5.9292 6.9026 6.14705 7.19621L6.21967 7.28033L11.3462 12.4069L6.21967 17.5334L6.14705 17.6175C5.9292 17.9111 5.9534 18.3278 6.21967 18.594C6.51256 18.8869 6.98744 18.8869 7.28033 18.594L12.4069 13.4675L17.5334 18.594C17.8263 18.8869 18.3011 18.8869 18.594 18.594C18.8603 18.3278 18.8845 17.9111 18.6667 17.6175L18.594 17.5334L13.4675 12.4069L18.594 7.28033L18.6667 7.19621C18.8845 6.9026 18.8603 6.48594 18.594 6.21967Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }